import { CodeBlock } from '@crowdex/ui/ai/code-block';
import { ToolContent, ToolHeader } from '@crowdex/ui/ai/tool';
import { lineCount } from '@/lib/conversations/message-part/text';
import type { DiffPart } from '@/lib/conversations/message-part/types';
import { DiffCounts } from './diff-counts';
import { StableTool } from './stable-tool';

export function DiffToolCard({ data }: { data: DiffPart['data'] }) {
  const additions = lineCount(data.newText);
  const deletions = lineCount(data.oldText);
  return (
    <StableTool className="py-0.5 text-muted-foreground">
      <ToolHeader
        action="Edited"
        details={<DiffCounts additions={additions} deletions={deletions} />}
        state="output-available"
        title={data.path}
        type="tool-edit"
      />
      <ToolContent className="py-2">
        <CodeBlock
          className="border-hairline [&_code]:text-xs! [&_pre]:p-3! [&_pre]:text-xs!"
          code={data.newText}
          language="typescript"
        />
      </ToolContent>
    </StableTool>
  );
}
